/**
 * joe-banner-svg — layout is CSS-driven.
 * Provides light image enhancements + theme-editor reload safety.
 */
(function () {
  function enhance(container) {
    if (!container || container.dataset.joeBannerSvgReady === 'true') return;
    container.dataset.joeBannerSvgReady = 'true';

    container.querySelectorAll('img').forEach(function (img) {
      if (!img.hasAttribute('decoding')) {
        img.setAttribute('decoding', 'async');
      }
      // Below-fold icon/feature images; leave banner images as-is (often LCP-ish when used)
      if (
        img.closest('.joe-banner-svg_items') &&
        !img.hasAttribute('loading')
      ) {
        img.setAttribute('loading', 'lazy');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.joe-banner-svg_container').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    if (!root) return;
    if (root.classList && root.classList.contains('joe-banner-svg_container')) {
      root.dataset.joeBannerSvgReady = '';
      enhance(root);
      return;
    }
    var container = root.querySelector && root.querySelector('.joe-banner-svg_container');
    if (container) {
      container.dataset.joeBannerSvgReady = '';
      enhance(container);
    }
  });
})();
